<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import {
  useSelectRegarding,
} from '../../../../model/additional-info/support/info-customer-request/select-regarding.hook'

defineOptions({
  name: 'SelectRegarding',
})

const {
  placeholder,
  model,
  options,
} = useSelectRegarding()
</script>

<template>
  <AppSelect
    v-model="model"
    :options="options"
    :placeholder="placeholder"
  />
</template>
